import React, { useState, useMemo } from 'react';
import { Card, Btn, Field, Input } from '../components/UI';
import { buildLetterheadHtml, openLetterheadDocument } from '../utils/letterheadHtml';

const MONTHS = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'];
function todayLong() {
  const d = new Date();
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

const lbl = { fontFamily: 'var(--mono)', fontSize: 10, fontWeight: 400, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 7, display: 'block' };
const inp = { width: '100%', padding: '11px 13px', fontSize: 14, background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', color: 'var(--text)', boxSizing: 'border-box', fontFamily: 'var(--font)' };

export default function LetterheadPage() {
  const [colorway, setColorway] = useState('dark');
  const [date, setDate]         = useState(todayLong());
  const [greeting, setGreeting] = useState('Dear —');
  const [body, setBody]         = useState('');
  const [signName, setSignName] = useState('Shehryar');
  const [signRole, setSignRole] = useState('Founder');

  const opts = { colorway, date, greeting, body, signName, signRole };
  const html = useMemo(() => buildLetterheadHtml(opts), [colorway, date, greeting, body, signName, signRole]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 className="t-h1">Letterhead</h1>
          <p className="t-sub" style={{ marginTop: 4 }}>Type your letter, place it on the STR letterhead, and download it print-ready.</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <div className="segmented">
            <button className={colorway === 'dark' ? 'active' : ''} onClick={() => setColorway('dark')}>Dark</button>
            <button className={colorway === 'light' ? 'active' : ''} onClick={() => setColorway('light')}>Light</button>
          </div>
          <Btn variant="success" onClick={() => { if (!openLetterheadDocument(opts)) window.alert('Allow pop-ups to open the letterhead.'); }}>↓ Download</Btn>
        </div>
      </div>

      <div className="grid-chart" style={{ alignItems: 'start' }}>
        {/* Editor */}
        <Card style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="grid-half" style={{ gap: 14 }}>
            <Field label="Date"><Input value={date} onChange={e => setDate(e.target.value)} /></Field>
            <Field label="Greeting"><Input value={greeting} onChange={e => setGreeting(e.target.value)} placeholder="Dear —" /></Field>
          </div>
          <div>
            <label style={lbl}>Letter body</label>
            <textarea value={body} onChange={e => setBody(e.target.value)} rows={12}
              placeholder={'Write your letter here.\n\nLeave a blank line between paragraphs.'}
              style={{ ...inp, resize: 'vertical', lineHeight: 1.6, minHeight: 220 }} />
          </div>
          <div className="grid-half" style={{ gap: 14 }}>
            <Field label="Signed by"><Input value={signName} onChange={e => setSignName(e.target.value)} /></Field>
            <Field label="Role"><Input value={signRole} onChange={e => setSignRole(e.target.value)} /></Field>
          </div>
        </Card>

        {/* Live preview */}
        <Card style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '13px 18px', borderBottom: '1px solid var(--border)', fontFamily: 'var(--mono)', fontSize: 10, fontWeight: 400, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--text3)' }}>Preview</div>
          <div style={{ background: colorway === 'light' ? '#EDE9E0' : '#0A0A0C', display: 'flex', justifyContent: 'center', padding: 14 }}>
            <iframe title="Letterhead preview" srcDoc={html}
              style={{ width: 620, height: 876, border: 'none', transform: 'scale(0.62)', transformOrigin: 'top center', background: 'transparent' }} />
          </div>
        </Card>
      </div>
    </div>
  );
}
